export const LANDING_PAGE_VALUES = [
  'Discover, inquire, book the perfect vendors',
  'Vendors and venues for every budget',
  'Plus, personalized recs to match your style',
];
